import * as tslib_1 from "tslib";
import { EntityStore, StoreConfig } from '@datorama/akita';
import * as i0 from "@angular/core";
var NotificationsStore = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsStore, _super);
    function NotificationsStore() {
        return _super.call(this, { loading: false, savedParents: {} }) || this;
    }
    NotificationsStore.ngInjectableDef = i0.defineInjectable({ factory: function NotificationsStore_Factory() { return new NotificationsStore(); }, token: NotificationsStore, providedIn: "root" });
    NotificationsStore = tslib_1.__decorate([
        StoreConfig({ name: 'notifications' }),
        tslib_1.__metadata("design:paramtypes", [])
    ], NotificationsStore);
    return NotificationsStore;
}(EntityStore));
export { NotificationsStore };
